import React from 'react';
import { DeepPageWithShell } from './DeepPage';
import { usePageMeta } from '../../lib/useMeta';
import { serviceSchema } from '../../lib/schema';

const PATH = '/self-defense';

const DATA = {
  breadcrumbs: [
    { label: 'Home', href: '/' },
    { label: 'Training' },
    { label: 'Practical Self-Defense' },
  ],
  eyebrow: 'Practical Self-Defense',
  h1: 'Self-Defense Classes in Colorado Springs',
  tagline: 'Real-World \u00B7 Scenario-Based \u00B7 For Every Age',
  intro:
    'Universal Kempo Karate\u2019s self-defense training is built on more than four decades of Kempo instruction. We teach practical, scenario-based self-defense inside our regular classes \u2014 not as a one-off seminar, but as a core part of every student\u2019s training.',
  heroImage: 'https://customer-assets.emergentagent.com/job_kempo-patch/artifacts/jep1mog3_513826107_10235910162761820_6628217572269810338_n.jpeg',
  heroImageAlt: 'Self-defense training at Universal Kempo Karate',
  callouts: [
    { title: 'Real Scenarios', body: 'Grab defenses, strike defenses, ground escapes, and awareness drills.' },
    { title: 'Zero Ego', body: 'Taught at your pace. Build skill before intensity.' },
    { title: 'Every Age', body: 'Kids learn anti-bully defense. Teens and adults learn street-aware response.' },
  ],
  featureList: [
    'De-escalation and awareness first',
    'Strike, grab, and ground defenses',
    'Controlled, respectful partner drills',
    'Scenario work with multiple attackers',
    'Family-friendly environment',
    'Instructors with decades of experience',
  ],
  sections: [
    {
      eyebrow: 'Our Approach',
      heading: 'Awareness first. Technique second. Force last.',
      body: [
        'The best self-defense is not getting into the fight. We teach students \u2014 at every age \u2014 to read a situation, position themselves well, use their voice, and leave if they can. Only when there is no better option do we train the physical response.',
        'When physical response is necessary, our Kempo curriculum gives students a complete toolkit: strikes, blocks, grappling, locks, and ground escapes.',
      ],
    },
    {
      eyebrow: 'For Kids and Teens',
      heading: 'Anti-bully and situational safety.',
      body: [
        'For kids, self-defense means recognizing a bully, standing tall, using words first, and knowing exactly what to do if someone grabs or hits them. For teens, it extends into real situational awareness: cars, parties, strangers, and the quiet confidence that discourages trouble in the first place.',
      ],
    },
    {
      eyebrow: 'For Adults',
      heading: 'The confidence to walk through the world.',
      body: [
        'For adults, our self-defense training is woven into every class. You will drill scenarios slowly, then at speed, with trusted partners. The goal is not to turn you into a fighter \u2014 it is to give you the physical and mental tools to handle a bad moment and get home.',
      ],
    },
  ],
  ctaCopy: 'Try a Free Self-Defense Class',
  source: 'page-self-defense',
};

const SelfDefensePage = () => {
  usePageMeta({
    title: 'Self-Defense Classes in Colorado Springs | Universal Kempo Karate',
    description:
      'Practical self-defense classes in Colorado Springs \u2014 taught inside every Kempo karate class. Awareness-first, scenario-based training for kids, teens, and adults.',
    path: PATH,
    breadcrumbs: DATA.breadcrumbs,
    schemas: [
      {
        id: 'self-defense-service-jsonld',
        data: serviceSchema({
          name: 'Self-Defense Classes',
          description: 'Practical, scenario-based self-defense training inside every Kempo karate class.',
          slug: PATH,
          serviceType: 'Self-Defense Instruction',
        }),
      },
    ],
  });
  return <DeepPageWithShell data={DATA} />;
};

export default SelfDefensePage;
